import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { LargeCard } from "components/home/Home";
import BrexCardIcon from "static/images/BrexCardIcon.svg";

export const BrexHomeCard = () => {
  return (
    <LargeCard block>
      <div className="t-h-full t-min-h-[132px] t-w-full t-bg-surface-lighter-grey t-rounded-lg t-border t-border-solid t-border-neutral-10 t-flex t-flex-col t-gap-3 t-p-5 md:t-flex-row md:t-items-start md:t-justify-between sm:t-justify-center">
        <div className="t-flex t-gap-3 t-items-start">
          <img
            className="t-h-8 t-w-8 sm:t-shrink-0"
            src={BrexCardIcon}
            alt=""
          />
          <div className="t-flex t-flex-col t-gap-1">
            <div className="t-text-subtext t-text-text-100">
              Brex offers the highest-returning, lowest-risk treasury product.
              Period.
            </div>
            <div className="t-text-body-sm t-text-text-30">
              Switch to Brex and earn up to 4.35%† with same-hour liquidity, no
              minimums, no hidden fees. That's smarter spending.
            </div>
          </div>
        </div>
        <ConditionalLink
          to="/community/perks/brex"
          className="t-block t-w-fit sm:t-ml-11"
        >
          <Button customType="secondary" size="small">
            Apply now
          </Button>
        </ConditionalLink>
      </div>
    </LargeCard>
  );
};
